/* eslint-disable react/prop-types */
import React from 'react'
import isArray from 'lodash/isArray'
import { compose, withState } from 'recompose'
import withTemporaryForm from 'hocs/bases/withTemporaryForm'
import { withSortableCollection } from 'hocs/bases/withSortableCollection'
import ItemUpdater from 'components/wrappers/ItemUpdater'
import TextSwitcher from 'components/forms/bases/TextSwitcher'
import CircleAddButton from 'components/Button/CircleAddButton'
import FormInput from 'components/forms/bases/FormInput'
import { updateItemArrayByIndex } from 'helpers/arrayHelpers'
import Wrapper from 'components/wrappers/Wrapper'
import RaisedButton from 'material-ui/RaisedButton'

const EnhancedTextSwitcher = ItemUpdater.Enhance(TextSwitcher)

const FormList = compose(
  withSortableCollection({ dataSet: 'empty' }),
)(
  ({
    item,
    index,
    onSubmit,
    onDeleteByIndex,
    onUpdateStringByIndex,
  }) => (
    <EnhancedTextSwitcher
      value={item}
      sortable
      dividing
      inputProps={{
        placeholder: 'Product SKU',
      }}
      onDelete={() => onDeleteByIndex(index)}
      onSave={(val) => {
        onUpdateStringByIndex(index, val)
        onSubmit(index, val)
        return Promise.resolve()
      }}
    />
  ),
)

const FormSkuList = compose(
  withTemporaryForm({ predicate: isArray }),
  withState('sku', 'setSku', ''),
)(
  ({
    value,
    onChange,
    onRawChange,
    createOnSubmit,
    sku,
    setSku,
  }) => (
    <Wrapper.Panel>
      <FormList
        collection={value}
        onUpdate={onChange}
        onRawChange={onRawChange}
        onSubmit={(index, val) => createOnSubmit(
          (skuList, updateElement) => updateElement(
            updateItemArrayByIndex(skuList, index, () => val),
          ),
        )}
        hideAddButton
        renderAddButton={({ onAddToLast }) => (
          <CircleAddButton centered onClick={onAddToLast} />
        )}
      />
      <Wrapper padding={'1rem 30px'}>
        <FormInput
          value={sku}
          onChange={setSku}
          placeholder={'Product SKU'}
        />
        <Wrapper textAlign={'right'} mt={1}>
          <RaisedButton
            label={'Add'}
            disabled={sku === ''}
            secondary
            onTouchTap={() => {
              const newData = [...value, sku]
              onChange(newData)
              onRawChange(newData)
              return setSku('')
            }}
          />
        </Wrapper>
      </Wrapper>
    </Wrapper.Panel>
  ),
)

FormSkuList.propTypes = {}
FormSkuList.defaultProps = {}

export default FormSkuList



// WEBPACK FOOTER //
// ./src/components/forms/FormSkuList.js